// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Reservation packages index (Stitch Clinical Precision) ——— */
.rp-screen {
  box-sizing: border-box;
  padding: 24px;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rp-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid #F1F5F9;
}

.rp-heading__left {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.rp-heading__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.rp-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.rp-title-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.rp-count {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid #E2E8F0;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  background: #F1F5F9;
  color: #475569;
}

.rp-subtitle {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: #64748B;
}

.rp-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.rp-btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.rp-btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.rp-btn--primary .anticon {
  font-size: 14px;
}

.rp-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.rp-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 280px;
  min-width: 0;
  max-width: 320px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.rp-search:focus-within {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.rp-search__icon {
  flex-shrink: 0;
  color: #94A3B8;
  font-size: 16px;
  margin-inline-end: 8px;
}

.rp-search__input.ant-input-affix-wrapper,
.rp-search__input.ant-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 34px !important;
  padding: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 12px;
}

.rp-search__input.ant-input-affix-wrapper .ant-input {
  font-size: 12px;
}

.rp-status-filter {
  min-width: 160px;
}

.rp-status-filter.ant-select .ant-select-selector {
  height: 38px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  font-size: 12px;
}

.rp-status-filter.ant-select .ant-select-selection-item,
.rp-status-filter.ant-select .ant-select-selection-placeholder {
  line-height: 36px !important;
}

.rp-table-card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
}

.rp-list {
  height: auto;
  min-height: 120px;
  min-width: 0;
}

.rp-table-scroll {
  width: 100%;
  overflow-x: auto;
  min-width: 0;
}

.rp-table {
  /* id | patient | mobile | package | status | price | action */
  --rp-cols: 56px minmax(0, 1.5fr) minmax(0, 1.1fr) minmax(0, 1.4fr) 132px 140px 76px;
  display: grid;
  grid-template-columns: var(--rp-cols);
  width: 100%;
  min-width: 960px;
  font-size: 12px;
  background: #ffffff;
}

.rp-table.no-action {
  --rp-cols: 56px minmax(0, 1.5fr) minmax(0, 1.1fr) minmax(0, 1.4fr) 132px 140px;
  min-width: 880px;
}

.rp-table.is-fetching {
  opacity: 0.72;
}

.rp-table__head,
.rp-table__row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: stretch;
  margin: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
}

.rp-table__head {
  border-bottom: 1px solid #E2E8F0;
}

.rp-table__head .rp-cell {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  background: #F8FAFC !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.rp-table__row {
  cursor: pointer;
  border-bottom: 1px solid #F1F5F9;
}

.rp-table__row:last-child {
  border-bottom: 0;
}

.rp-table__row .rp-cell {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 6px 12px;
  color: #334155;
  min-width: 0;
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  transition: background 0.12s ease;
}

.rp-table__row:hover .rp-cell {
  background: #F8FAFC !important;
}

.rp-cell.is-price {
  justify-content: flex-start;
  text-align: start;
}

.rp-table__head .rp-cell.is-action {
  justify-content: flex-start;
  text-align: start;
}

.rp-table__row .rp-cell.is-action {
  justify-content: flex-end;
  text-align: end;
}

[dir='rtl'] .rp-table__row .rp-cell.is-action {
  justify-content: flex-start;
  text-align: start;
}

.rp-id,
.rp-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #64748B;
  line-height: 1.25;
}

.rp-patient {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.rp-avatar {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0369A1;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.rp-patient__name {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  color: #0F172A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rp-package {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rp-price {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: #0F172A;
}

.rp-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
}

.rp-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.rp-status.is-available {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.rp-status.is-available .rp-status__dot {
  background: #059669;
}

.rp-status.is-partial {
  background: #F0F9FF;
  color: #0284C7;
  border-color: #BAE6FD;
}

.rp-status.is-partial .rp-status__dot {
  background: #0EA5E9;
}

.rp-status.is-settled {
  background: #F0FDFA;
  color: #0D9488;
  border-color: #99F6E4;
}

.rp-status.is-settled .rp-status__dot {
  background: #0D9488;
}

.rp-status.is-cancelled {
  background: #FEF2F2;
  color: #B91C1C;
  border-color: #FECACA;
}

.rp-status.is-cancelled .rp-status__dot {
  background: #EF4444;
}

.rp-row-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.rp-row-link:hover {
  color: #0284C7;
}

[dir='rtl'] .rp-row-link .anticon {
  transform: scaleX(-1);
}

.rp-empty {
  padding: 40px 24px;
  text-align: center;
  color: #94A3B8;
}

.rp-empty p {
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 500;
}

.rp-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  font-size: 12px;
}

.rp-pager__meta {
  color: #64748B;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}

.rp-pager__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rp-pager__btn {
  box-sizing: border-box;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.rp-pager__btn:hover:not(:disabled) {
  background: #F8FAFC;
}

.rp-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.rp-pager__page {
  font-variant-numeric: tabular-nums;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  min-width: 72px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReservationPackages/style.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8DAA8D;EAC9D,mFAAmF;EACnF,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;EAEE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* ——— Reservation packages index (Stitch Clinical Precision) ——— */\n.rp-screen {\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rp-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.rp-heading__left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.rp-heading__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.rp-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.rp-title-row h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.rp-count {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid #E2E8F0;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  background: #F1F5F9;\n  color: #475569;\n}\n\n.rp-subtitle {\n  margin: 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748B;\n}\n\n.rp-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.rp-btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.rp-btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.rp-btn--primary .anticon {\n  font-size: 14px;\n}\n\n.rp-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.rp-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 280px;\n  min-width: 0;\n  max-width: 320px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.rp-search:focus-within {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.rp-search__icon {\n  flex-shrink: 0;\n  color: #94A3B8;\n  font-size: 16px;\n  margin-inline-end: 8px;\n}\n\n.rp-search__input.ant-input-affix-wrapper,\n.rp-search__input.ant-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 34px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 12px;\n}\n\n.rp-search__input.ant-input-affix-wrapper .ant-input {\n  font-size: 12px;\n}\n\n.rp-status-filter {\n  min-width: 160px;\n}\n\n.rp-status-filter.ant-select .ant-select-selector {\n  height: 38px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  font-size: 12px;\n}\n\n.rp-status-filter.ant-select .ant-select-selection-item,\n.rp-status-filter.ant-select .ant-select-selection-placeholder {\n  line-height: 36px !important;\n}\n\n.rp-table-card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.rp-list {\n  height: auto;\n  min-height: 120px;\n  min-width: 0;\n}\n\n.rp-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.rp-table {\n  /* id | patient | mobile | package | status | price | action */\n  --rp-cols: 56px minmax(0, 1.5fr) minmax(0, 1.1fr) minmax(0, 1.4fr) 132px 140px 76px;\n  display: grid;\n  grid-template-columns: var(--rp-cols);\n  width: 100%;\n  min-width: 960px;\n  font-size: 12px;\n  background: #ffffff;\n}\n\n.rp-table.no-action {\n  --rp-cols: 56px minmax(0, 1.5fr) minmax(0, 1.1fr) minmax(0, 1.4fr) 132px 140px;\n  min-width: 880px;\n}\n\n.rp-table.is-fetching {\n  opacity: 0.72;\n}\n\n.rp-table__head,\n.rp-table__row {\n  display: grid;\n  grid-template-columns: subgrid;\n  grid-column: 1 / -1;\n  align-items: stretch;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n.rp-table__head {\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.rp-table__head .rp-cell {\n  display: flex;\n  align-items: center;\n  min-height: 32px;\n  padding: 6px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  background: #F8FAFC !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n}\n\n.rp-table__row {\n  cursor: pointer;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.rp-table__row:last-child {\n  border-bottom: 0;\n}\n\n.rp-table__row .rp-cell {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 6px 12px;\n  color: #334155;\n  min-width: 0;\n  background: #ffffff !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  transition: background 0.12s ease;\n}\n\n.rp-table__row:hover .rp-cell {\n  background: #F8FAFC !important;\n}\n\n.rp-cell.is-price {\n  justify-content: flex-start;\n  text-align: start;\n}\n\n.rp-table__head .rp-cell.is-action {\n  justify-content: flex-start;\n  text-align: start;\n}\n\n.rp-table__row .rp-cell.is-action {\n  justify-content: flex-end;\n  text-align: end;\n}\n\n[dir='rtl'] .rp-table__row .rp-cell.is-action {\n  justify-content: flex-start;\n  text-align: start;\n}\n\n.rp-id,\n.rp-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #64748B;\n  line-height: 1.25;\n}\n\n.rp-patient {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.rp-avatar {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0369A1;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.rp-patient__name {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #0F172A;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rp-package {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rp-price {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: #0F172A;\n}\n\n.rp-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.rp-status__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.rp-status.is-available {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.rp-status.is-available .rp-status__dot {\n  background: #059669;\n}\n\n.rp-status.is-partial {\n  background: #F0F9FF;\n  color: #0284C7;\n  border-color: #BAE6FD;\n}\n\n.rp-status.is-partial .rp-status__dot {\n  background: #0EA5E9;\n}\n\n.rp-status.is-settled {\n  background: #F0FDFA;\n  color: #0D9488;\n  border-color: #99F6E4;\n}\n\n.rp-status.is-settled .rp-status__dot {\n  background: #0D9488;\n}\n\n.rp-status.is-cancelled {\n  background: #FEF2F2;\n  color: #B91C1C;\n  border-color: #FECACA;\n}\n\n.rp-status.is-cancelled .rp-status__dot {\n  background: #EF4444;\n}\n\n.rp-row-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.rp-row-link:hover {\n  color: #0284C7;\n}\n\n[dir='rtl'] .rp-row-link .anticon {\n  transform: scaleX(-1);\n}\n\n.rp-empty {\n  padding: 40px 24px;\n  text-align: center;\n  color: #94A3B8;\n}\n\n.rp-empty p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.rp-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  font-size: 12px;\n}\n\n.rp-pager__meta {\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n}\n\n.rp-pager__controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rp-pager__btn {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.rp-pager__btn:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.rp-pager__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.rp-pager__page {\n  font-variant-numeric: tabular-nums;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 72px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
